// extracted by mini-css-extract-plugin
module.exports = {"calendar":"style_calendar__Pccuw"};